import { capitalCase } from 'change-case'

// Most position values title-case into something an AE recognizes (`right_hand_column` reads as
// "Right Hand Column"). These are the ones that don't, or that Ads Manager names differently.
export const labelOverrides: Record<string, string> = {
  right_hand_column: 'Right Column',
  instant_article: 'Instant Articles',
  biz_disco_feed: 'Business Explore',
  facebook_reels: 'Reels',
  facebook_reels_overlay: 'Reels Overlay',
  ig_search: 'Search Results',
  explore_home: 'Explore Home',
  profile_feed: 'Profile Feed',
  profile_reels: 'Profile Reels',
  stream: 'Feed',
  classic: 'Native, Banner and Interstitial',
  instream_video: 'In-Stream Video',
  rewarded_video: 'Rewarded Video',
  messenger_home: 'Inbox',
}

export const placementLabel = (position: string): string =>
  labelOverrides[position] ?? capitalCase(position)
